enum IconsEnum {
  plus = 1,
  trash = 2,
  pencil = 3,
  'menu-right' = 4,
  save = 5,
  edit = 6,
  download = 7,
  leaf = 8,
  compressed = 9,
  lock = 10,
  user = 11,
  'thumbs-up' = 12,
  cutlery = 13,
  'map-marker' = 14,
  globe = 15,
  success = 16,
  ok = 17,
  hourglass = 18,
  fire = 19,
  open = 20,
  star = 21,
  cog = 22,
  right_menu = 23,
  drag = 24,
  chevron_down = 25,
  chevron_up = 26,
  education = 27,
  resize = 28,
  help = 29,
  info = 30,
  filterOutline = 31,
  search = 32,
  libra = 33,
  cube = 34,
  carabine = 35,
  backpack = 36,
  ax = 37,
  close = 38,
  watch = 39,
  check = 40,
  male = 41,
  female = 42,
  chart = 43,
  basket = 44,
  print = 45,
  shopping = 46,
  square = 47,
  circle = 48,
  squareChecked = 49,
  refresh = 50,
}
export default IconsEnum;
